import React from 'react';
import { Button, Popover, Tag, Typography } from 'antd';
import { VideoCameraOutlined } from '@ant-design/icons';
import { F } from '@/utils/intl';
import { VideoCallModel } from '@/typings/models/ServiceRequest';
import styles from './index.less';

const { Paragraph } = Typography;

export interface VideoLinkButtonProps {
  videoCall?: VideoCallModel;
  size?: 'small' | 'middle' | 'large';
  shape?: 'default' | 'circle' | 'round';
  showText?: boolean;
  variant?: 'text' | 'link' | 'outlined' | 'dashed' | 'filled';
  color?: 'default' | 'primary' | 'danger' | 'green';
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const VideoLinkButton: React.FC<VideoLinkButtonProps> = ({
  videoCall,
  size = 'small',
  shape = 'round',
  showText = false,
  variant = 'filled',
  color = 'primary',
  className,
  onClick,
}) => {
  if (!videoCall) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
    window.open(videoCall.host_join_url, '_blank', 'noopener,noreferrer');
  };

  const buttonText = <F id="pages.serviceRequest.joinVideoCall" defaultMessage="Join Video Call" />;
  const popoverTitle = showText ? null : buttonText;

  const popoverContent = (
    <div style={{ maxWidth: 300 }} onClick={e => e.stopPropagation()}>
      <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
        <Tag bordered={false} color={"lime"}>Host</Tag>
        <a
          className={styles.joinLink}
          href={videoCall.host_join_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Teilnehmen
        </a>

        <Paragraph
          copyable={{ text: videoCall.host_join_url }}
          style={{ marginBottom: 0, display: 'inline' }}
        >
          {''}
        </Paragraph>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Tag color={"geekblue"} bordered={false}>Gast</Tag>
        <a
          href={videoCall.guest_join_url}
          target="_blank"
          className={styles.joinLink}
          rel="noopener noreferrer"
        >
          Teilnehmen
        </a>
        <Paragraph
          copyable={{ text: videoCall.guest_join_url }}
          style={{ marginBottom: 0, display: 'inline' }}
        >
          {''}
        </Paragraph>
      </div>
    </div>
  );

  const button = (
    <Button
      size={size}
      shape={shape}
      color={color}
      variant={variant}
      icon={<VideoCameraOutlined />}
      onClick={handleClick}
      className={className}
    >
      {showText && <F id="pages.serviceRequest.joinVideoCall" defaultMessage="Join Video Call" />}
    </Button>
  );

  return (
    <Popover content={popoverContent} title={popoverTitle} trigger="hover">
      {button}
    </Popover>
  );
};

export default VideoLinkButton;
